module.exports = __webpack_public_path__ + "static/media/clevered_white.4913b5bb.png";